import { clickInEditor } from './skin';

const wait = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); });

/**
 * Abre desde fuera del iframe herramientas que viven dentro del editor. Un solo sitio para el portal
 * (OfficeShell) y la app del teléfono (AppOffice). Devuelve false si el control todavía no existe.
 */
export async function runEditorAction(iframe, action) {
  switch (action) {
    case 'history':
      clickInEditor(iframe, '.ribtab a[data-tab="review"]');
      await wait(250);
      return clickInEditor(iframe, ['#slot-btn-history button', '#slot-btn-history .btn-toolbar', '#btn-version-history']);
    // La tira lateral puede estar oculta (modo app): se pulsa igual
    case 'comments':
      return clickInEditor(iframe, '#left-btn-comments', { hidden: true });
    case 'search':
      return clickInEditor(iframe, '#left-btn-searchbar', { hidden: true });
    case 'navigation':
      return clickInEditor(iframe, '#left-btn-navigation', { hidden: true });
    case 'present':
      // 9.4: botón de reproducir de la barra (Inicio); el de la barra de estado ya no existe
      return clickInEditor(iframe, ['#id-toolbar-btn-preview > button:first-child', '#id-toolbar-btn-preview button', '#btn-preview'], { hidden: true });
    case 'theme':
      return clickInEditor(iframe, '.ribtab a[data-tab="design"]');
    case 'image':
      clickInEditor(iframe, '.ribtab a[data-tab="ins"]');
      await wait(150);
      return clickInEditor(iframe, ['#tlbtn-insertimage button', '#tlbtn-insertimage', '[id*="insertimage"] button']);
    default:
      return false;
  }
}
